const APIRoutesForClient = {
	GetRecipes: `https://api.sampleapis.com/recipes/recipes`,
	GetRecipesFromUI: `${window.location.href}/assets/recipes.json`
};

module.exports = APIRoutesForClient;